import { ExclamationIcon, InformationCircleIcon } from '@heroicons/react/solid'
import { c, FC } from 'lib/component-utils'

type Props = {
  type: 'error' | 'warning' | 'info'
  header?: string
  text?: JSX.Element | string
}

const types = {
  error: {
    icon: ExclamationIcon,
    bgColor: 'bg-red-100',
    ringColor: 'ring-red-200',
    iconColor: 'text-red-400',
    headerColor: 'text-red-800',
    textColor: 'text-red-700',
  },
  warning: {
    icon: ExclamationIcon,
    bgColor: 'bg-yellow-100',
    ringColor: 'ring-yellow-200',
    iconColor: 'text-yellow-400',
    headerColor: 'text-yellow-800',
    textColor: 'text-yellow-700',
  },
  info: {
    icon: InformationCircleIcon,
    bgColor: 'bg-white',
    ringColor: 'ring-gray-200',
    iconColor: 'text-blue-400',
    headerColor: 'text-gray-800',
    textColor: 'text-gray-700',
  },
}

const Alert: FC<Props> = ({ type, header, text, className, children }) => {
  const styles = types[type]
  const Icon = styles.icon

  return (
    <div
      className={c`p-4 mb-4 rounded-md ring-1 ${styles.bgColor} ${styles.ringColor} ${className}`}
    >
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon className={c`w-5 h-5 ${styles.iconColor}`} aria-hidden="true" />
        </div>
        <div className="ml-3 space-y-1">
          {header && <h3 className={c`text-sm font-medium ${styles.headerColor}`}>{header}</h3>}
          {text && <div className={c`text-sm ${styles.textColor}`}>{text}</div>}
          {children && <div className={c`text-sm ${styles.textColor}`}>{children}</div>}
        </div>
      </div>
    </div>
  )
}

export default Alert
